import React from 'react';
import CompanyWelcome from '../CompanyWelcome/CompanyWelcome';

const ModuleCompanyWelcome = ({
  companyWelcome,
  companyWelcomeVersion,
  homePageConfiguration,
}) => {
  const tagMenuModule = homePageConfiguration.find(
    item => item.moduleType === 'Tag_menu'
  );
  if (!!tagMenuModule && tagMenuModule.moduleVersion === 2) {
    return null;
  }
  return (
    <div>
      <CompanyWelcome
        companyWelcome={companyWelcome}
        companyWelcomeVersion={companyWelcomeVersion}
      />
    </div>
  );
};
export default ModuleCompanyWelcome;
